/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `ALLSCRIPTS` - Allscripts
 * * `CERNER` - Cerner
 * * `EPIC` - Epic
 * * `EVIDENT` - Evident
 * * `MCKESSON` - McKesson
 * * `MEDHOST` - Medhost
 * * `MEDITECH` - Meditech
 * * `PARAGON` - Paragon
 * * `SOARIAN` - Soarian
 * * `TRUBRIDGE` - TruBridge
 * * `T-SHEETS` - T-sheets
 * * `OTHER` - Other
 */
export enum EmrEnum {
    ALLSCRIPTS = 'ALLSCRIPTS',
    CERNER = 'CERNER',
    EPIC = 'EPIC',
    EVIDENT = 'EVIDENT',
    MCKESSON = 'MCKESSON',
    MEDHOST = 'MEDHOST',
    MEDITECH = 'MEDITECH',
    PARAGON = 'PARAGON',
    SOARIAN = 'SOARIAN',
    TRUBRIDGE = 'TRUBRIDGE',
    T_SHEETS = 'T-SHEETS',
    OTHER = 'OTHER',
}
